import { ISupplierRegionsService } from 'dm-src/services/suppliers/isupplier-regions-service';
import { Inject, Injectable } from '@angular/core';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DeliveryPlanType } from 'dm-src/types/delivery-plan-type';
import { SupplierRegionsData } from 'dm-src/models/supplier-regions-data';
import { SupplierRegion } from 'dm-src/models/supplier-region';
import { API_CLIENT_SERVICE_IMPL, IAPIClientService, ISelectOption } from 'shared';
import { UnassignedTimeSlotPlan } from 'dm-src/models/unassigned-time-slot-plan';
import { DeliveryPlan } from 'dm-src/models/delivery-plan';

@Injectable()
export class SupplierRegionsService implements ISupplierRegionsService {
    constructor(@Inject(API_CLIENT_SERVICE_IMPL) private _apiClient: IAPIClientService) {}

    public getSupplierRegionsData(): Observable<HttpResponse<SupplierRegionsData>> {
        return this._apiClient.getWithResponse<SupplierRegionsData>(`supplierRegions`);
    }

    public getRegionFilterOptions(): Observable<HttpResponse<ISelectOption[]>> {
        return this._apiClient.getWithResponse<ISelectOption[]>(
            `supplierRegions/filterOptions`
        );
    }

    public saveSupplierRegionsData(
        supplierRegions: SupplierRegion[]
    ): Observable<HttpResponse<SupplierRegion[]>> {
        return this._apiClient.putWithResponse<SupplierRegion[]>(
            `supplierRegions`,
            supplierRegions
        );
    }

    public replanRoutes(
      supplierRegionID: string,
      deliveryDate: string,
      deliveryPlanType: DeliveryPlanType,
      useCurrentTime: boolean
    ): Observable<HttpResponse<any>> {
        return this._apiClient.postWithResponse<any>(
            `supplierRegions/replan-routes/`,
            {
        supplierRegionID,
        deliveryDate,
        deliveryPlanType,
        useCurrentTime
    }
        );
    }

    public planUnassignedTimeSlots(
        supplierRegionID: string,
        deliveryDate: string
    ): Observable<HttpResponse<UnassignedTimeSlotPlan>> {
        return this._apiClient.postWithResponse<UnassignedTimeSlotPlan>(
            'supplierRegions/plan-unassigned-time-slots',
            {
                supplierRegionId: supplierRegionID,
                deliveryDate,
            }
        );
    }

    public publishDeliveryPlan(
    supplierRegionID: string,
    deliveryDate: Date
): Observable<HttpResponse<void>> {

    return this._apiClient.postWithResponse<void>(
        'delivery-optimization/publish-delivery-plan',
        {
            supplierRegionId: supplierRegionID,
            deliveryDate
        });
}

    public getDeliveryPlan(
        supplierRegionID: string,
        deliveryDate: string,
        deliveryPlanType: DeliveryPlanType,
        courierID?: string
    ): Observable<HttpResponse<DeliveryPlan>>
    {
        let params = new HttpParams()
            .set('supplierRegionId', supplierRegionID)
            .set('deliveryDate', deliveryDate)
            .set('deliveryPlanType', deliveryPlanType);

        if (courierID)
            params = params.set('courierId', courierID);

        return this._apiClient.getWithResponse<DeliveryPlan>(
            'delivery-optimization/delivery-plan',
            undefined,
            params
        );
    }

    public deleteSupplierRegion(
        supplierRegionID: string
    ): Observable<HttpResponse<void>> {
        return this._apiClient.deleteWithResponse<void>(
            `supplierRegions/${supplierRegionID}`
        );
    }
}
